import {request} from 'helpers/services/utils/request';
import {GET, POST} from 'helpers/services/constants/API_CONSTANTS';
import {FIND_DELIVERY} from 'helpers/services/constants/API_ENDPOINTS';

export const findDeliveryGetOrderApi = async (id) => {
  return request(POST, FIND_DELIVERY(id), {});
};

export default findDeliveryGetOrderApi;
